import { useState, useEffect } from 'react';

export const useTypewriter = (strings: string[], delay: number, pause: number = 2000) => {
  const [index, setIndex] = useState(0);
  const [length, setLength] = useState(0);
  const [step, setStep] = useState(1);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) {
      const pauseTimeout = setTimeout(() => setIsPaused(false), pause);

      return () => clearTimeout(pauseTimeout);
    }

    const timeoutId = setTimeout(() => {
      setLength(prevLength => {
        const nextLength = prevLength + step;

        // Если строка полностью набрана
        if (nextLength === strings[index].length) {
          setStep(-1);
          setIsPaused(true);
        }

        // Если строка полностью удалена
        if (nextLength === 0) {
          setStep(1);
          setIndex(prevIndex => (prevIndex + 1) % strings.length); // Перейти к следующей строке
        }

        return nextLength;
      });
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [length, step, strings, delay, index]);

  return strings[index]?.slice(0, length) || '';
};
